import { PaletteOptions } from "@mui/material";

const palette: PaletteOptions = {
  primary: {
    main: "#2196F3",
    dark: "#1E88E5",
    light: "#42A5F5",
  },
  error: {
    light: "#EF5350",
    main: "#D32F2F",
    dark: "#C62828",
  },
};

export default palette;
